import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import axios from "axios";
import { set, isEmpty, get } from "lodash";
import { datadogRum } from "@datadog/browser-rum";
import { getUrlAuthToken, getIsOnpremise } from ".";
import redirectToLogin from "./redirectToLogin";
import constants from "./constants";
import getEnv from "../utils/getEnv";
var TIMEOUT = 180000;
var MAX_RETRIES = 3;
var RETRY_DELAY = 1000;
var isOnpremise = getIsOnpremise();
export var getBackendURL = function getBackendURL() {
  var _window;
  if (typeof window === "undefined") {
    return getEnv("NEXT_PUBLIC_API_URL");
  }
  if (!isOnpremise) {
    return getEnv("NEXT_PUBLIC_API_URL");
  }
  var hostname = (_window = window) === null || _window === void 0 ? void 0 : _window.location.hostname;
  return "http://".concat(hostname, ":").concat(getEnv("NEXT_PUBLIC_ONPREMISE_BACKEND_PORT"));
};
var axiosConnect = axios.create({
  baseURL: getBackendURL(),
  timeout: TIMEOUT,
  withCredentials: true
  // exposedHeaders: ["set-cookie"] // there is no such key called exposedHeaders in type AxiosRequestConfig
});
axiosConnect.interceptors.request.use(/*#__PURE__*/function () {
  var _interceptorFunc = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(config) {
    var qXRProjectURLs, baseURL, url, params, isUserInfoCall, urlAuthToken;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // if (
          //   config.method === "post" ||
          //   config.method === "patch" ||
          //   config.method === "put" ||
          //   config.method === "delete"
          // ) {
          //   const cookies = getCookies();
          //   const csrfToken = get(cookies, ["csrftoken"], "");
          //   if (csrfToken) {
          //     set(config, ["headers", servicesUtils.X_CSRF], csrfToken);
          //   }
          // }
          qXRProjectURLs = ["/auth/", "/login/", "/logout/", "/csrf/"];
          if (config.url && qXRProjectURLs.indexOf(config.url) === -1) {
            set(config, ["url"], "".concat(config.url));
          }
          baseURL = config.baseURL, url = config.url, params = config.params;
          isUserInfoCall = (url === null || url === void 0 ? void 0 : url.includes("/userinfo")) || (url === null || url === void 0 ? void 0 : url.includes("/profile"));
          urlAuthToken = getUrlAuthToken();
          if (urlAuthToken && !isUserInfoCall && params) {
            params["url_auth_token"] = urlAuthToken;
          }
          if (!isEmpty(baseURL)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, Promise.reject({
            noValidUrl: true
          }));
        case 1:
          return _context.a(2, config);
      }
    }, _callee);
  }));
  function interceptorFunc(_x) {
    return _interceptorFunc.apply(this, arguments);
  }
  return interceptorFunc;
}());
axiosConnect.interceptors.response.use(function (response) {
  return Promise.resolve(response);
}, function (err) {
  var errorStatus = get(err, ["response", "status"]);
  var url = get(err, ["config", "url"], "");
  var config = get(err, "config", {});
  var isUserInfoCall = get(err, ["config", "url"], "").includes("/userinfo");
  var stopRedirectLogin = get(err, ["config", "params", "stopRedirectLogin"], false);
  var isUrlAuthToken = !!getUrlAuthToken();
  var code = err.code,
    message = err.message;
  // if ([400, 403, 404, 500, 502, 503, 504].indexOf(errorStatus) !== -1) {
  //   // log 4xx, 5xx errors, not logging 401
  //   SentryIntegration.logError(err)
  // }

  if (code === "ECONNABORTED" || message !== null && message !== void 0 && message.includes("timeout")) {
    var maxRetries = config.maxRetries || MAX_RETRIES;
    var retryCount = config.retryCount || 0;
    if (retryCount < maxRetries) {
      retryCount++;
      return new Promise(function (resolve) {
        setTimeout(function () {
          return resolve(axiosConnect(_objectSpread(_objectSpread({}, config), {}, {
            retryCount: retryCount
          })));
        }, config.retryDelay || RETRY_DELAY);
      });
    }
  }
  if (errorStatus === 401 && !stopRedirectLogin && window.location.pathname !== "/landing-page" && window.location.pathname !== "/notifications-widget" && window.location.pathname !== "/auth/login" && !isUrlAuthToken) {
    var redirectLogin = localStorage.getItem("redirectLogin");
    if (redirectLogin) {
      localStorage.removeItem("redirectLogin");
      redirectToLogin();
    } else {
      var _window2;
      // The original URL the user came from
      var redirectURL = window.location.pathname;
      (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.localStorage) === null || _window2 === void 0 || _window2.setItem(constants.PERSISTED.redirectAfterLogin, redirectURL);
      window.location.href = window.location.origin + "/landing-page";
    }
  } else {
    /* eslint-disable no-console */
    console.error("Invalid request", err);
    if (getEnv("NEXT_PUBLIC_APP_ENV") === "production" && window.location.pathname !== "/landing-page") {
      var error = new Error("XHR Error - ".concat(errorStatus), {
        cause: err
      });
      datadogRum.addError(error, {
        scope: "xhr-error",
        url: url
      });
    }
  }
  return Promise.reject(err);
});
export default axiosConnect;